import { PointsReward } from '@sg/graphql-schema';

/**
 * Given a list of point rewards and a current points value, return the next reward.
 * Next reward meaning the first reward whose point requirements are not met by the current points value.
 */
export const useNextUnlockableReward = (props: UseNextRewardNameProps) => {
  const { availablePoints, pointsRewards } = props;

  const nextReward = pointsRewards.find((reward) => availablePoints < (reward.points ?? 0));

  if (!nextReward) return;

  return {
    id: nextReward.id,
    name: nextReward.name.toLocaleLowerCase(),
    points: nextReward.points,
    pointsLeft: nextReward.points - availablePoints,
  };
};

// ─── Types ──────────────────────────────────────────────────────────────────

type UseNextRewardNameProps = {
  availablePoints: number;
  pointsRewards: readonly Omit<PointsReward, 'displayName'>[];
};
